import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex shrink-0 items-center pl-1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["ComboboxAnchor"], {
        "data-slot": "combobox-anchor",
        class: _normalizeClass($setup.cn($setup.anchorVariants({ disabled: $props.disabled, readonly: $props.readonly, hasError: $props.hasError }), $setup.props.class))
    }, {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default"),
            (_ctx.$slots.append)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "append")
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["class"]));
}
